export const environment = {
  production: true,
  api: 'https://reenstudio-api.intrapresasrl-dev.it',
  // api: 'https://u0jueb7r26.execute-api.eu-south-1.amazonaws.com/DEV',
  apiHeaders: { 'x-client': 'WEB' },
  googleMapsApiKey: 'AIzaSyAA_ugiTH_enrmHyutMVOba1nXSgnfG9iU',
};
